import React, { useState, FC } from 'react';
import { useTranslate } from 'react-admin';
import { Grid } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { BlockButton, Confirmation, TextInput } from '~/components';
import { Account, ExternalSource } from '~/types';
import onError from '~/errorsHandler';
import { blockAccount as apiBlockAccount } from '~/api/accounts';

interface BlockAccountButtonProps {
  resource: 'accounts' | 'externalSources';
  record: Account | ExternalSource;
  refetch: () => void;
}

const BlockAccountButton: FC<BlockAccountButtonProps> = (props) => {
  const { record, refetch, resource } = props;
  const translate = useTranslate();
  const t = (key: string, args?: any): string =>
    translate(`resources.accounts.actions.${key}`, args);
  const [note, setNote] = useState('');
  const [errorMessage, setErrorMessage] = useState<string>();
  const handleNote = ({ target }: any) => {
    setErrorMessage(undefined);
    setNote(target?.value);
  };
  const blockAccount = (
    accountId: string,
    accountType: 'accounts' | 'externalSources',
    note: string
  ) => {
    apiBlockAccount(accountId, accountType, note).catch(onError).finally(refetch);
  };
  return (
    <Confirmation
      onConfirm={() => {
        blockAccount(record.id, resource, note);
        setNote('');
      }}
      confirmButtonProps={{
        disabled: !note,
      }}
      confirmationSettings={{
        variant: 'modal',
        modal: {
          heading: t('attention'),
          content: (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Alert severity='warning'>{t('blockingAlert', { accountType: t(resource) })}</Alert>
              </Grid>
              <Grid item xs={12}>
                <TextInput
                  autoFocus
                  label={t('reason')}
                  onChange={handleNote}
                  value={note}
                  multiline
                  rows={5}
                  rowsMax={20}
                  error={!!errorMessage}
                  helperText={errorMessage}
                  required
                />
              </Grid>
            </Grid>
          ),
        },
      }}
    >
      <BlockButton />
    </Confirmation>
  );
};

export default BlockAccountButton;
